import { DialogFooter } from '@/ui_v3';
import { cn } from '@/utils';
import { BuildGenerateAction, type GenerateStatus } from '@/views/build/modal/BuildAiModal/components/BuildAiGenerateAction';
import { SaveQuizAction } from '../SaveQuizAction';
import { type GenerationMode } from '../types';
export const BuildAiModalFooter = ({
  status,
  onSave,
  onGenerate,
  onCancel,
  saveDisabled = false,
  isQuotaLimited = false,
  isQuotaExhausted = false,
  isLoadingQuota = false,
  generationMode,
  onGenerationModeChange,
  lockedModes,
  shouldShowModeCoachMark
}: {
  status: GenerateStatus;
  onSave: () => void;
  onGenerate?: () => void;
  onCancel: () => void;
  saveDisabled?: boolean;
  isQuotaLimited?: boolean;
  isQuotaExhausted?: boolean;
  isLoadingQuota?: boolean;
  generationMode?: GenerationMode;
  onGenerationModeChange?: (mode: GenerationMode) => void;
  lockedModes?: readonly GenerationMode[];
  shouldShowModeCoachMark?: boolean;
}) => {
  if (status === 'success' || status === 'regenerating') {
    return <DialogFooter className="relative border-t border-alternative !py-md">
        <SaveQuizAction onConfirm={onSave} onCancel={onCancel} disabled={saveDisabled} />
      </DialogFooter>;
  }

  // 쿼터 제한 유저가 로딩 중이거나 소진 시 생성 버튼 숨김
  const shouldHideGenerateAction = isQuotaLimited && (isLoadingQuota || isQuotaExhausted);
  return <DialogFooter className={cn('tablet-sm:hidden shadow-reversed-sm !py-xs', status === 'generating' && 'hidden', shouldHideGenerateAction && 'hidden')} data-sentry-element="DialogFooter" data-sentry-component="BuildAiModalFooter" data-sentry-source-file="BuildAiModalFooter.tsx">
      <BuildGenerateAction className="flex" onGenerate={onGenerate} onCancel={onCancel} status={status} generationMode={generationMode} onGenerationModeChange={onGenerationModeChange} lockedModes={lockedModes} shouldShowModeCoachMark={shouldShowModeCoachMark} data-sentry-element="BuildGenerateAction" data-sentry-source-file="BuildAiModalFooter.tsx" />
    </DialogFooter>;
};